<template>
  <div class="wrapper">
    <v-head @backTop="backTop"></v-head>
    <div class="content-body">
      <v-sidebar></v-sidebar>
      <div class="content-box" ref="contentBox">
        <div class="content">
          <transition name="move" mode="out-in">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="move" mode="out-in">
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import vHead from './Header.vue'
  import vSidebar from './Sidebar.vue'
  import bus from './bus'

  export default {
    data() {
      return {
        tagsList: [],
        collapse: false
      }
    },
    components: {
      vHead,
      vSidebar
    },
    created() {
      bus.$on('collapse', msg => {
        this.collapse = msg
      })
      // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
      bus.$on('tags', msg => {
        let arr = []
        for (let i = 0, len = msg.length; i < len; i++) {
          msg[i].name && arr.push(msg[i].name)
        }
        this.tagsList = arr
      })
    },
    methods: {
      backTop(data) {
        // console.log(data)
        this.$refs.contentBox.scrollTo(0, 0)
      }
    }
  }
</script>
<style lang="less" scoped>
  .content-body {
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: fixed;
    top: 63px;
  }

  .content-box {
    padding: 24px;
    height: calc(100% - 108px);
  }

  .content {
    height: 100%;
    width: 100%;
  }
</style>
